import { render, staticRenderFns } from "./CustomerTakeOrder.vue?vue&type=template&id=045c148d"
import script from "./CustomerTakeOrder.vue?vue&type=script&lang=js"
export * from "./CustomerTakeOrder.vue?vue&type=script&lang=js"
import style0 from "./CustomerTakeOrder.vue?vue&type=style&index=0&id=045c148d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports